import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import s from './Tooltip.module.scss';
import classNames from 'classnames';

const Tooltip = ({
    content,
    direction = 'top',
    delay = 200,
    children,
    showTemporary = false,
    temporaryDuration = 2000,
}) => {
    const [active, setActive] = useState(false);
    const [isTemporaryActive, setIsTemporaryActive] = useState(false);
    const timeoutRef = useRef();

    const showTip = () => {
        if (isTemporaryActive) return;

        timeoutRef.current = setTimeout(() => {
            setActive(true);
        }, delay);
    };

    const hideTip = () => {
        if (isTemporaryActive) return;

        clearTimeout(timeoutRef.current);
        setActive(false);
    };

    useEffect(() => {
        if (showTemporary) {
            setActive(true);
            setIsTemporaryActive(true);

            const timer = setTimeout(() => {
                setActive(false);
                setIsTemporaryActive(false);
            }, temporaryDuration);

            return () => clearTimeout(timer);
        }
    }, [showTemporary, temporaryDuration]);

    const classes = classNames(s.Tooltip, s[direction], {
        [s.Active]: active,
        [s.TemporaryActive]: isTemporaryActive,
    });

    return (
        <div
            className={s.Wrapper}
            onMouseEnter={showTip}
            onMouseLeave={hideTip}>
            {children}
            {active && <div className={classes}>{content}</div>}
        </div>
    );
};

Tooltip.propTypes = {
    content: PropTypes.node.isRequired,
    direction: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
    delay: PropTypes.number,
    children: PropTypes.node.isRequired,
    showTemporary: PropTypes.bool,
    temporaryDuration: PropTypes.number,
};

export default Tooltip;
